import { Injectable } from "@angular/core";
import { isNativePlatform } from "./platform.service";

@Injectable({ providedIn: "root" })
export class EstimateShareService {
  /**
   * Native: opens the iOS share sheet with the estimate HTML as a file so the
   * user can Save to Files / AirDrop / Message. Returns true when native.
   * Web: returns false — caller keeps using window.print().
   */
  async shareHtml(title: string, html: string): Promise<boolean> {
    if (!isNativePlatform()) return false;
    try {
      const { Share } = await import("@capacitor/share");
      const { Capacitor } = await import("@capacitor/core");
      const { Filesystem, Directory, Encoding } = await import(
        "@capacitor/filesystem"
      );
      const fileName = `${title.replace(/[^\w-]+/g, "_")}.html`;
      await Filesystem.writeFile({
        directory: Directory.Cache,
        path: `estimates/${fileName}`,
        data: html,
        encoding: Encoding.UTF8,
        recursive: true,
      });
      const base = await Filesystem.getUri({
        directory: Directory.Cache,
        path: "estimates",
      });
      const fileUri = `${base.uri}/${fileName}`;
      await Share.share({
        title,
        url: Capacitor.convertFileSrc(fileUri),
        dialogTitle: "Share estimate",
      });
      return true;
    } catch (err) {
      // Fall back to the web print path rather than leaving the user stuck.
      console.error("Native estimate share failed:", err);
      return false;
    }
  }
}
